module.exports = __webpack_public_path__ + "img/02：Trofeo-1.851d1a3b.jpg";